<template>
  <div>
    <div class="contain">
      <p class="title" >账号已经正常退出！</p>
    </div>
    <div class="foot">
      <van-button type="default" @click="onBackHome">返回首页</van-button>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    onBackHome() {
      this.$router.replace("/");
    },
  },
  created() {
    this.$store.dispatch({ type: "Logout" }).then(() => {});
  }
};
</script>

<style lang="less" scoped>
.contain {
  padding: 0 0 5px 0;
  .title{
    color:red;
    font-weight: 600;
    text-align: center;
    font-size: 18px;
    padding: 10px;

  }
}
.foot {
  text-align: center;
}
</style>
